import { mapState } from 'vuex';
import i18n from '@/lang/index.js';
export default {
  props: {
    initOperateData: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      cloudProxy: false,
      regionOptions: [{
        value: '1',
        label: 'North America'
      }, {
        value: '2',
        label: 'Europe'
      }, {
        value: '3',
        label: 'India'
      }, {
        value: '4',
        label: 'Japan'
      }, {
        value: '5',
        label: 'South East Asia'
      }, {
        value: '6',
        label: 'China'
      }],
      value: '1'
    };
  },
  computed: {
    ...mapState({
      State: state => state,
      partyCode: state => state.partyCode
    })
  },
  watch: {
    'initOperateData.cloudProxy': {
      handler: function (newValue) {
        if (newValue) {
          this.cloudProxy = true;
        } else {
          this.cloudProxy = false;
        }
      },
      immediate: true
    }
  },
  filters: {
    showRegions(value) {
      if (value === 'North America') {
        return i18n.t('setting.northAmerica');
      } else if (value === 'Europe') {
        return i18n.t('setting.europe');
      } else if (value === 'India') {
        return i18n.t('setting.india');
      } else if (value === 'Japan') {
        return i18n.t('setting.japan');
      } else if (value === 'South East Asia') {
        return i18n.t('setting.southEastAsia');
      } else if (value === 'China') {
        return i18n.t('setting.china');
      } else {
        return value;
      }
    }
  },
  methods: {
    changeCloudProxy(value) {
      const params = {
        buttonType: 7,
        operationType: value ? 1 : 0
      };
      this.axios.post(`/partyline-backend/partyAction/button?partyCode=${this.partyCode}`, params).then(res => {
        if (res.data.errorCode === '0x0') {
          let message = this.$t('setting.onCloud');
          if (this.cloudProxy) {
            this.$emit('changeButtonFlag', 1, 'cloudProxy');
          } else {
            this.$emit('changeButtonFlag', 0, 'cloudProxy');
            message = this.$t('setting.offCloud');
          }
          this.$message.success(message);
        }
      });
    }
  }
};